import { useState } from 'react';
import Dialog from '@mui/material/Dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Paper } from '@mui/material';

/* 	InputIcon 
 *	@params id 			string	 	identificador input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params onChange	function 	function change	
 */

 const icons = [
  { name: 'abacus', 	icon: ["fal", "abacus"] },
  { name: 'alarm clock', 	icon: ["fal", "alarm-clock"] },
  { name: 'anchor', 	icon: ["fal", "anchor"] },
  { name: 'apple alt', 	icon: ["fal", "apple-alt"] },
  { name: 'archive', 	icon: ["fal", "archive"] },
  { name: 'atlas', 	icon: ["fal", "atlas"] },
  { name: 'atom', 	icon: ["fal", "atom"] },
  { name: 'award', 	icon: ["fal", "award"] },
  { name: 'baby', 	icon: ["fal", "baby"] },
  { name: 'backpack', 	icon: ["fal", "backpack"] },
  { name: 'bacteria', 	icon: ["fal", "bacteria"] },
  { name: 'bacterium', 	icon: ["fal", "bacterium"] },
  { name: 'badge check', 	icon: ["fal", "badge-check"] },
  { name: 'balance scale', 	icon: ["fal", "balance-scale"] },
  { name: 'balance scale right', 	icon: ["fal", "balance-scale-right"] },
  { name: 'balance scale left', 	icon: ["fal", "balance-scale-left"] },
  { name: 'ball pile', 	icon: ["fal", "ball-pile"] },
  { name: 'ballot', 	icon: ["fal", "ballot"] },
  { name: 'ballot check', 	icon: ["fal", "ballot-check"] },
  { name: 'baseball', 	icon: ["fal", "baseball"] },
  { name: 'baseball ball', 	icon: ["fal", "baseball-ball"] },
  { name: 'batteryfull', 	icon: ["fal", "battery-full"] },
  { name: 'bell', 	icon: ["fal", "bell"] },
  { name: 'bell school', 	icon: ["fal", "bell-school"] },
  { name: 'bells', 	icon: ["fal", "bells"] },
  { name: 'bezier curve', 	icon: ["fal", "bezier-curve"] },
  { name: 'binoculars', 	icon: ["fal", "binoculars"] },
  { name: 'bomb', 	icon: ["fal", "bomb"] },
  { name: 'bong', 	icon: ["fal", "bong"] },
  { name: 'book', 	icon: ["fal", "book"] },
  { name: 'book alt', 	icon: ["fal", "book-alt"] },
  { name: 'bookmark', 	icon: ["fal", "bookmark"] },
  { name: 'books', 	icon: ["fal", "books"] },
  { name: 'box', 	icon: ["fal", "box"] },
  { name: 'box alt', 	icon: ["fal", "box-alt"] },
  { name: 'box ballot', 	icon: ["fal", "box-ballot"] },
  { name: 'box check', 	icon: ["fal", "box-check"] },
  { name: 'boxes', 	icon: ["fal", "boxes"] },
  { name: 'brain', 	icon: ["fal", "brain"] },
  { name: 'bring forward', 	icon: ["fal", "bring-forward"] },
  { name: 'bring front', 	icon: ["fal", "bring-front"] },
  { name: 'brush', 	icon: ["fal", "brush"] },
  { name: 'bug', 	icon: ["fal", "bug"] },
  { name: 'building', 	icon: ["fal", "building"] },
  { name: 'burn', 	icon: ["fal", "burn"] },
  { name: 'business-time', 	icon: ["fal", "business-time"] },
  { name: 'cabinet-filing', 	icon: ["fal", "cabinet-filing"] },
  { name: 'calculator-alt', 	icon: ["fal", "calculator-alt"] },
  { name: 'calendar', 	icon: ["fal", "calendar"] },
  { name: 'camera', 	icon: ["fal", "camera"] },
  { name: 'campfire', 	icon: ["fal", "campfire"] },
  { name: 'capsules', 	icon: ["fal", "capsules"] },
  { name: 'certificate', 	icon: ["fal", "certificate"] },
  { name: 'chart area', 	icon: ["fal", "chart-area"] },
  { name: 'chart line', 	icon: ["fal", "chart-line"] },
  { name: 'child', 	icon: ["fal", "child"] },
  { name: 'clipboard list', 	icon: ["fal", "clipboard-list"] },
  { name: 'clipboard list check', 	icon: ["fal", "clipboard-list-check"] },
  { name: 'clipboard check', 	icon: ["fal", "clipboard-check"] },
  { name: 'code', 	icon: ["fal", "code"] },
  { name: 'code branch', 	icon: ["fal", "code-branch"] },
  { name: 'cog', 	icon: ["fal", "cog"] },
  { name: 'cogs', 	icon: ["fal", "cogs"] },
  { name: 'coin', 	icon: ["fal", "coin"] },
  { name: 'coins', 	icon: ["fal", "coins"] },
  { name: 'comment', 	icon: ["fal", "comment"] },
  { name: 'crop-alt', 	icon: ["fal", "crop-alt"] },
  { name: 'deaf', 	icon: ["fal", "deaf"] },
  { name: 'debug', 	icon: ["fal", "debug"] },
  { name: 'dewpoint', 	icon: ["fal", "dewpoint"] },
  { name: 'dice', 	icon: ["fal", "dice"] },
  { name: 'diploma', 	icon: ["fal", "diploma"] },
  { name: 'donate', 	icon: ["fal", "donate"] },
  { name: 'external link alt', 	icon: ["fal", "external-link-alt"] },
  { name: 'eye', 	icon: ["fal", "eye"] },
  { name: 'fan', 	icon: ["fal", "fan"] },
  { name: 'file', 	icon: ["fal", "file"] },
  { name: 'file certificate', 	icon: ["fal", "file-certificate"] },
  { name: 'fire', 	icon: ["fal", "fire"] },
  { name: 'flag', 	icon: ["fal", "flag"] },
  { name: 'folder', 	icon: ["fal", "folder"] },
  { name: 'function', 	icon: ["fal", "function"] },
  { name: 'futbol', 	icon: ["fal", "futbol"] },
  { name: 'gamepad', 	icon: ["fal", "gamepad"] },
  { name: 'galaxy', 	icon: ["fal", "galaxy"] },
  { name: 'ghost', 	icon: ["fal", "ghost"] },
  { name: 'globe', 	icon: ["fal", "globe"] },
  { name: 'globe americas', 	icon: ["fal", "globe-americas"] },
  { name: 'graduation cap', 	icon: ["fal", "graduation-cap"] },
  { name: 'landmark alt', 	icon: ["fal", "landmark-alt"] },
  { name: 'language', 	icon: ["fal", "language"] },
  { name: 'lightbulb exclamation', 	icon: ["fal", "lightbulb-exclamation"] },
  { name: 'music', 	icon: ["fal", "music"] },
  { name: 'object group', 	icon: ["fal", "object-group"] },
  { name: 'omega', 	icon: ["fal", "omega"] },
  { name: 'palette', 	icon: ["fal", "palette"] },
  { name: 'pencil paintbrush', 	icon: ["fal", "pencil-paintbrush"] },
  { name: 'phone laptop', 	icon: ["fal", "phone-laptop"] },
  { name: 'photo video', 	icon: ["fal", "photo-video"] },
  { name: 'pi', 	icon: ["fal", "pi"] },
  { name: 'running', 	icon: ["fal", "running"] },
  { name: 'school', 	icon: ["fal", "school"] },
  { name: 'scroll old', 	icon: ["fal", "scroll-old"] },
  { name: 'shapes', 	icon: ["fal", "shapes"] },
  { name: 'shield', 	icon: ["fal", "shield"] },
  { name: 'shield check', 	icon: ["fal", "shield-check"] },
  { name: 'sliders h', 	icon: ["fal", "sliders-h"] },
  { name: 'sliders v', 	icon: ["fal", "sliders-v"] },
  { name: 'square root alt', 	icon: ["fal", "square-root-alt"] },
  { name: 'star', 	icon: ["fal", "star"] },
  { name: 'theater masks', 	icon: ["fal", "theater-masks"] },
  { name: 'tint', 	icon: ["fal", "tint"] },
  { name: 'user friends', 	icon: ["fal", "user-friends"] },
  { name: 'wifi', 	icon: ["fal", "wifi"] },
  { name: 'wifi-slash', 	icon: ["fal", "wifi-slash"] },
]


const InputIcon = ({ id, value, onChange, disabled }) => {
  const [showIcons, setShowIcons] = useState(false)
  const [icon, setIcon] = useState(value)
  
  return (
    <div>
      {icon ? 
      <FontAwesomeIcon 
        id={id}
        className={`text-x-max clickeable color-primary-black`}
        icon={value}
        onClick={disabled ?  undefined: () => setShowIcons(!showIcons)}
        onBlur={() => setShowIcons(false)}
      />
        :
      <div onClick={disabled ?  undefined: () => setShowIcons(!showIcons)} className="text-clickeable">Select an icon</div>
      }
      { showIcons &&
        <Dialog
          open={showIcons}
          className='container-module-inner-content container-dashboard-ligth h-100'
          style={{ backgroundColor: 'transparent' }}
        >
          <Paper className='p-r-10'>
            <Grid container alignItems='center' className='m-0 h-40-vh' style={{ overflow: 'auto' }} spacing={1}>
              { icons.map((item) => (
                <Grid item xs>
                  <Paper alignItems='center' className={`clickeable text-center ${JSON.stringify(item.icon) === JSON.stringify(icon) ? 'bg-third-blue color-primary-white' : ''} `} style={{ width: 100, height: 120 } } onClick={() => setIcon(item.icon)}>
                    <FontAwesomeIcon className='p-t-30 p-b-4 text-center' icon={item.icon} style={{ fontSize: '3em' }} />
                    <p className='text-small text-center'>{item.name}</p> 
                  </Paper>
                </Grid>
              ))
              }
            </Grid>
            <div className='box-end w-100'>
              <FontAwesomeIcon icon="times" className='text-clickeable text-large p-10' onClick={() => {
                setShowIcons(false)
              }} />            
              <FontAwesomeIcon icon="check" className='text-clickeable text-large p-10' onClick={() => {
                onChange(icon)
                setShowIcons(false)
              }} />
            </div>
          </Paper>
        </Dialog>
      }
    </div>
  )
}
    
export default InputIcon